
import { supabase } from '@/lib/supabase';
import { v4 as uuidv4 } from 'uuid';

export const uploadFile = async (file: File, bucketName = 'img'): Promise<string> => {
  try {
    // Create a unique file name using UUID
    const fileExt = file.name.split('.').pop();
    const fileName = `${uuidv4()}.${fileExt}`;
    const filePath = `${fileName}`;

    // Upload the file to the specified bucket (defaults to 'img')
    const { data, error } = await supabase.storage
      .from(bucketName)
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) throw error;

    // Get public URL for the file
    const { data: urlData } = supabase.storage
      .from(bucketName)
      .getPublicUrl(filePath);

    return urlData.publicUrl;
  } catch (error) {
    console.error('Error uploading file to storage:', error);
    throw error;
  }
};

export const deleteFile = async (filePath: string, bucketName = 'img'): Promise<void> => {
  try {
    const { error } = await supabase.storage
      .from(bucketName)
      .remove([filePath]);

    if (error) throw error;
  } catch (error) {
    console.error('Error deleting file from storage:', error);
    throw error;
  }
};
